import React from "react";
import ThemeConstants from "../../../../config/theme/theme_constants";
import UvibesPointIcon from '../../../../assets/images/uvibes_point.svg?react';
import { useTranslation } from "../../../../i18n/useTranslation";

const CurrentPoints: React.FC<{ experience?: number, className?: string }> = ({ experience, className }) => {
    const { t } = useTranslation();
    const theme = ThemeConstants();

    return (
        <div
          className={`flex items-center justify-center px-3 py-4.5 rounded-[18px] gap-2 ${className}`}
          style={{ background: theme.backgroundColor, border: `1px solid ${theme.UvibesPink}` }}
        >
            {experience !== undefined ? (<>
                <UvibesPointIcon className="h-4.5 w-auto"/>
                <p className="text-xs font-light text-center">
                    <span className="font-semibold">{`${experience} `}</span>
                    {t('common.unit.points', { count: experience })}
                </p>
            </>) : (<div className="animate-spin w-4 h-4 border-2 border-primary border-t-transparent rounded-full my-0.25 mx-7.25"/>)}

        </div>
    );
}

export default CurrentPoints;